import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { Search } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import SearchDropdown from "./SearchDropdown";

const SearchBar = ({ placeholder = "Search", fullWidth = true }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const searchContainerRef = useRef(null);

  // Handle input change
  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    setIsDropdownOpen(value.length >= 2);
  };

  // Handle input focus
  const handleInputFocus = () => {
    if (searchQuery.length >= 2) {
      setIsDropdownOpen(true);
    }
  };

  // Handle clicking outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle dropdown item click
  const handleDropdownItemClick = (item) => {
    console.log("Selected item:", item);
    setIsDropdownOpen(false);
    setSearchQuery(""); // Clear search after selection
  };

  return (
    <Box
      ref={searchContainerRef}
      sx={{
        width: fullWidth ? "100%" : "auto",
        maxWidth: 600,
        position: "relative",
      }}
    >
      <TextField
        value={searchQuery}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        placeholder={placeholder}
        variant="outlined"
        size="medium"
        fullWidth={fullWidth}
        autoComplete="off"
        data-cy="global-search-input"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search
                size={20}
                style={{
                  color: "var(--mui-palette-text-secondary)",
                }}
              />
            </InputAdornment>
          ),
          sx: {
            backgroundColor: "background.paper",
            height: "40px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "1px solid",
              borderColor: "divider",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "text.secondary",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "2px solid",
              borderColor: "primary.main",
            },
            "& .MuiInputBase-input": {
              padding: "12px 14px 12px 0",
              fontSize: "16px",
              "&::placeholder": {
                color: "text.secondary",
                opacity: 0.7,
              },
            },
          },
        }}
      />
      <SearchDropdown
        isOpen={isDropdownOpen}
        searchQuery={searchQuery}
        onItemClick={handleDropdownItemClick}
      />
    </Box>
  );
};

export default SearchBar;
